<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Zmiana nr rachunku bankowego
  </div>

  <div  fxFlex="100">
    <mat-form-field fxFlex="100">
      <mat-label>Numer rachunku bankowego</mat-label>
      <input
        prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
        matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387" [formControl]="accountNumberControl"
      >
      <mat-error *ngIf="accountNumberControl.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

